import { LIST_EVENTS } from '../../../apollo/queries/event'
import { gql, useMutation, useQuery } from '@apollo/client'
import settingImg from '../../../assets/icons/setting.svg'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import copy from '../../../assets/icons/copy.svg'
import Button from '../../../components/atoms/Buttons'
import { useUserContext } from '../../../context/UserContext'
import { useEffect, useRef, useState } from 'react'
import './style.css'
import { UPDATE_EVENT_VISIBILITY } from '../../../apollo/mutations/event'
import useOutsideClick from '../../../hooks/useOutsideClick'
import { getConsumerWebsiteOrigin } from '../../../utils/consumerWebsiteOrigin.js'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import Spinner from '../../../components/Spinner/Spinner'

dayjs.extend(advancedFormat)

function EventCard({
  loading,
  deleteLoading,
  EventsData,
  selectedEvents,
  onSelectEvent,
  emptyMessage = 'No Event Found',
}) {
  const { setCardId, setItems, setEditModal, setDefaultImage } =
    useUserContext()
  const [checkboxes, setCheckboxes] = useState({})
  const [updateEvent, {}] = useMutation(gql(UPDATE_EVENT_VISIBILITY), {
    refetchQueries: [{ query: LIST_EVENTS }],
  })
  const [dropdownsOpen, setDropdownsOpen] = useState({})
  const [copiedStates, setCopiedStates] = useState({})

  const handleCopyClick = (event, id) => {
    if (id) {
      const bookingLink = `${getConsumerWebsiteOrigin()}/event?eventId=${event.id}`
      navigator.clipboard
        .writeText(bookingLink)
        .then(() => {
          setCopiedStates(prev => ({
            ...prev,
            [id]: true,
          }))
          setTimeout(() => {
            setCopiedStates(prev => ({
              ...prev,
              [id]: false,
            }))
          }, 1500)
        })
        .catch(err => {
          console.error('Failed to copy:', err)
        })
    }
  }

  useEffect(() => {
    if (Array.isArray(EventsData)) {
      const initialCopiedStates = {}
      EventsData.forEach(event => {
        initialCopiedStates[event.id] = false
      })
      setCopiedStates(initialCopiedStates)
    }
  }, [EventsData])

  const dropdownRef = useRef(null)

  useOutsideClick(dropdownRef, () => {
    setDropdownsOpen({})
  })

  const handleDropdownToggle = (event, eventId) => {
    event.stopPropagation()
    setDropdownsOpen(prevState => {
      const newState = { ...prevState }
      Object.keys(newState).forEach(id => {
        if (id !== eventId) {
          newState[id] = false
        }
      })
      return {
        ...newState,
        [eventId]: !prevState[eventId],
      }
    })
  }

  const handleToggle = async (index, event) => {
    const newStatus = event?.visibility === 'ENABLED' ? 'DISABLED' : 'ENABLED'
    const eventId = event.id

    setCheckboxes(prev => ({
      ...prev,
      [eventId]: newStatus === 'ENABLED',
    }))

    try {
      await updateEvent({
        variables: {
          id: eventId,
          input: {
            visibility: newStatus,
          },
        },
        optimisticResponse: {
          __typename: 'Mutation',
          updateEvent: {
            __typename: 'Event',
            id: eventId,
            visibility: newStatus,
          },
        },
      })
    } catch (error) {
      console.error('Error updating event status:', error)
      setCheckboxes(prev => ({
        ...prev,
        [eventId]: event.visibility === 'ENABLED',
      }))
    }
  }

  const onHandleEditChange = async (event, eventId) => {
    setEditModal(true)
    setCardId(eventId)
    setItems(event)
    setDefaultImage(true)
  }

  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="w-full pb-16 mt-2 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-8 auto-rows-fr">
          {Array.isArray(EventsData) && EventsData.length === 0 ? (
            <div className="no_event_found text-[20px] md:text-[40px] col-span-full flex justify-center items-center min-h-[200px] py-16">
              {emptyMessage}
            </div>
          ) : (
            EventsData?.map((event, index) => {
              const isEnabled =
                checkboxes[event.id] ?? event.visibility === 'ENABLED'
              return (
              <div
                className={`w-full max-w-[520px] mx-auto sm:mx-0 min-h-[272px] flex flex-col ${
                  isEnabled
                    ? 'admin-event-card'
                    : 'admin-event-card-disabled'
                }`}
                key={event.id ?? index}
              >
                <div className="px-5 flex justify-between items-center shrink-0 mt-4">
                  <div>
                    <input
                      type="checkbox"
                      disabled={deleteLoading}
                      className={`w-4 h-4 ${
                        deleteLoading
                          ? 'cursor-not-allowed pointer-events-none'
                          : 'cursor-pointer'
                      }`}
                      onChange={() => onSelectEvent(event.id)}
                      checked={selectedEvents?.includes(event.id)}
                    />
                  </div>
                  <div className="">
                    {/* <img
                      src={settingImg}
                      alt="Setting"
                      className="cursor-pointer"
                      onClick={e => handleDropdownToggle(e, event.id)}
                    /> */}
                    {/* {dropdownsOpen[event.id] && ( */}
                    {/* <div
                        ref={dropdownRef}
                        className="w-[150px] h-[50px] bg-[#fff] dropdown px-2 z-10 absolute -bottom-12 rounded-[10px] right-0"
                      > */}
                    {/* <div className="flex justify-between items-center"> */}
                    {/* <p className="text-on">on/off</p> */}
                    <label
                      className={`inline-flex items-center cursor-pointer`}
                    >
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={isEnabled}
                        onChange={() => {
                          handleToggle(index, event)
                        }}
                      />
                      <div
                        className={`relative w-9 h-5 bg-gray-200 peer-focus:ring-blue-300 peer-focus:outline-none peer-focus:ring-4 ${
                          isEnabled
                            ? 'peer-checked:bg-[#2b364b]'
                            : 'bg-gray-200'
                        } rounded-full peer dark:bg-gray-700 ${
                          isEnabled
                            ? 'peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white'
                            : ''
                        } after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600`}
                      ></div>
                    </label>
                    {/* </div> */}
                    {/* </div> */}
                    {/* )} */}
                  </div>
                </div>
                <div className="px-5 flex justify-between gap-4 mt-5 flex-1 min-h-0">
                  <div className="min-w-0 flex-1">
                    <div
                      className={`line-clamp-2 ${
                        isEnabled
                          ? 'event-text'
                          : 'event-text-disabled'
                      } text-[17px] leading-snug`}
                      title={event?.eventName}
                    >
                      {event?.eventName}
                    </div>
                    <div className="event-mins mt-[6px]">
                      {event?.endDate
                        ? `${dayjs(event?.startDate).format(
                            'MMM Do YYYY',
                          )} - ${dayjs(event?.endDate).format('MMM Do YYYY')}`
                        : dayjs(event?.startDate).format('MMM Do YYYY')}
                    </div>
                    <div className="mt-[20px]">
                      <Link
                        onClick={() => {
                          if (isEnabled) {
                            const bookingLink = `${getConsumerWebsiteOrigin()}/event?eventId=${event.id}`
                            window.open(
                              bookingLink,
                              '_blank',
                              'noopener,noreferrer',
                            )
                          }
                        }}
                        className={`${
                          isEnabled
                            ? 'view-booking-page'
                            : 'view-booking-page_disabled'
                        }`}
                      >
                        View Booking Page
                      </Link>
                    </div>
                  </div>
                  <div className="shrink-0">
                    {event?.image ? (
                      <img
                        src={event?.image}
                        alt="Event"
                        className={`w-[88px] h-[88px] sm:w-24 sm:h-24 rounded-lg object-cover ${
                          !isEnabled ? 'gray-image' : ''
                        }`}
                      />
                    ) : (
                      <div
                        className={`w-[88px] h-[88px] sm:w-24 sm:h-24 rounded-lg bg-[#eee] ${
                          !isEnabled ? 'opacity-50' : ''
                        }`}
                        aria-hidden
                      />
                    )}
                  </div>
                </div>
                <hr className="horizontal-line mt-6 shrink-0" />
                <div className="flex flex-wrap justify-between items-center gap-2 px-5 py-4 mt-auto">
                  <button
                    className={`${
                      isEnabled
                        ? 'copy-link'
                        : 'copy-link_disabled'
                    } border-none bg-[#fff]`}
                    onClick={e => handleCopyClick(event, event.id)}
                  >
                    <img
                      src={copy}
                      alt="Copy"
                      className={`${
                        isEnabled ? '' : 'gray-image'
                      }`}
                    />
                    <span className="pl-[4px]">
                      {copiedStates[event.id] && isEnabled
                        ? 'Copied'
                        : 'Copy Link'}
                    </span>
                  </button>
                  <Button
                    className="upload_btn !text-[14px] cursor-pointer bg-[#fff]"
                    onClick={() => onHandleEditChange(event, event?.id)}
                  >
                    {event?.endDate != null ? 'Edit' : 'Edit / add details'}
                  </Button>
                </div>
              </div>
              )
            })
          )}
        </div>
      )}
    </div>
  )
}

export default EventCard
